namespace GeniuzPOS.ReportMasterData {
    export interface Report_1333Row {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDate?: string;
        PaymentType?: number;
        PaymentName?: string;
        GrossSales?: number;
        FullName?: string;
    }

    export namespace Report_1333Row {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'ReportMasterData.Report_1333';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDate = "DocDate",
            PaymentType = "PaymentType",
            PaymentName = "PaymentName",
            GrossSales = "GrossSales",
            FullName = "FullName"
        }
    }
}
